import React, { useContext, useEffect, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getAvailableSidesByStep } from "../../../FormulaGenerator/formulaHelpers";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const TherapySelectTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    dentalData,
    setStepFormula,
    setFormulaBeforeTreatment
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    setFormulaBeforeTreatment(data);
    toggleNextBtnState(false);
  }

  useEffect(() => {
    if (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => ["cariousTooth", "pulpitis", "badSealedCanal", "brokenToolCanal"].includes(el)))) {
      toggleNextBtnState(true);
    }
  }, [dentalData, toggleNextBtnState]);
  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "therapySelectTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "therapySelectTooth",
    availableSwitchers: availableSwitchers,
    hideJawStateSwitcher: false,
    jawStateEnabled: false,
    formulaHelperText: formulaHelperText
  }));
};

export default TherapySelectTooth;